<template>
<div>

    <!-- Modal -->
    <div class="modal fade" :id="'editarDatosCliente'+index" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Edición Datos Cliente
                    </h5>

                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <!--Formulario Datos Cliente inicio-->
                    <b-form>
                        <b-form-group id="input-group-1" label="Nombre Proyecto   :" label-for="input-1">
                            <b-form-input id="input-1" v-model="nombre" type="text" required placeholder="Nombre Proyecto"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-2" label="Dirección   :" label-for="input-2">
                            <b-form-input id="input-2" v-model="direccion" required placeholder="Dirección"></b-form-input>
                        </b-form-group>
                        <b-form-group id="input-group-3" label="Valor fp   :" label-for="input-3" v-b-tooltip.hover title="Página 30 Reglamento-de-Autogeneracion-Distribuida-de-Ley-21118.pdf">
                            <b-form-select id="input-3" v-model="fp" :options="fpvalores" required show: true> </b-form-select> {{fp}}
                        </b-form-group>
                        <b-form-group id="input-group-4" label="Representante  :" label-for="input-4">
                            <b-form-input id="input-4" v-model="representante" type="text" required placeholder="Representante" max="100"></b-form-input>
                        </b-form-group>

                        <b-container class="bv-example-row">
                            <b-row>
                                <b-col>
                                    <b-form-group id="input-group-5" label="Rut   :" label-for="input-5">
                                        <b-form-input id="input-5" v-model="rut" type="text" required placeholder="Ejemplo: 12345678-0" max="10" min="10"></b-form-input>
                                    </b-form-group>
                                </b-col>
                                <b-col>
                                    <b-form-group id="input-group-6" label="Teléfono :" label-for="input-6">
                                        <b-form-input id="input-6" v-model="telefono" type="number" required placeholder="998540025" max="12"></b-form-input>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-form>
                    <!--Formulario Datos Cliente fin-->
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal" data-placement="top" title="Cerrar"><i class="far fa-times-circle"></i></button>
                    <button type="button" class="btn btn-info" data-dismiss="modal" data-placement="top" title="Guardar" @click.prevent="editarDatosCliente"><i class="far fa-save"></i></button>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
export default {
    name: 'ModalEditarDatosCliente',
    props: [
        'index'
    ],
    data() {
        return {
            nombre: '',
            rut: '',
            direccion: '',
            fp: null,
            representante: '',
            idDoc: '',
            fpvalores: [],
            telefono: '',
        }
    },

    mounted() {
        this.nombre = this.$store.getters.enviarDataClientes[this.index].nombre;
        this.direccion = this.$store.getters.enviarDataClientes[this.index].direccion;

        this.fp = this.$store.getters.enviarDataClientes[this.index].fp;

        this.rut = this.$store.getters.enviarDataClientes[this.index].rut;
        this.telefono = this.$store.getters.enviarDataClientes[this.index].telefono;
        this.representante = this.$store.getters.enviarDataClientes[this.index].representante;
        this.idDoc = this.$store.getters.enviarDataClientes[this.index].idDoc;
        this.fpvalores = this.$store.getters.enviarDataFactorPlanta;
    },

    methods: {
        editarDatosCliente() {
            let auxiliarCliente = {
                idDoc: this.idDoc,
                nombre: this.nombre,
                direccion: this.direccion,
                fp: this.fp,
                representante: this.representante,
                rut: this.rut,
                telefono: this.telefono
            }
            this.$store.dispatch('editarDatosCliente', auxiliarCliente)

        }
    }

}
</script>

<style>

</style>
